import Phaser from "phaser";

export type ChevronPalette = {
  fill: number;
  stroke: number;
};

export const ZONE_TRANSIT_CHEVRON_PALETTE: ChevronPalette = {
  fill: 0xffe8a0,
  stroke: 0xfff5d6,
};

export const INTERIOR_EXIT_CHEVRON_PALETTE: ChevronPalette = {
  fill: 0xff4444,
  stroke: 0xffaaaa,
};

/** Shared chevron geometry — points left at rotation 0. */
export function ensureTransitChevronTexture(
  scene: Phaser.Scene,
  textureKey: string,
  palette: ChevronPalette
): void {
  if (scene.textures.exists(textureKey)) return;
  const g = scene.add.graphics();
  g.fillStyle(palette.fill, 0.88);
  g.lineStyle(2, palette.stroke, 0.95);
  const w = 50;
  const h = 32;
  const pad = 6;
  const ox = pad + w / 2;
  const oy = pad + h / 2;
  g.beginPath();
  g.moveTo(ox - w / 2, oy);
  g.lineTo(ox + w / 4, oy - h / 2);
  g.lineTo(ox + w / 4, oy - h / 6);
  g.lineTo(ox + w / 2, oy - h / 6);
  g.lineTo(ox + w / 2, oy + h / 6);
  g.lineTo(ox + w / 4, oy + h / 6);
  g.lineTo(ox + w / 4, oy + h / 2);
  g.closePath();
  g.fillPath();
  g.strokePath();
  g.generateTexture(textureKey, Math.ceil(w) + pad * 2, Math.ceil(h) + pad * 2);
  g.destroy();
}
